'use client'
import React, {useContext, useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {Box} from '@chakra-ui/layout';
import {FormControl, FormErrorMessage, Input, Button, Text, FormLabel} from '@chakra-ui/react';
import {forwardRef} from '@chakra-ui/system';
import { AuthContext } from '../lib/authContext';
import useTranslation from '../../lib/i18n/useTranslation';
const UpdatePasswordForm = forwardRef((props, ref) => {
  const {
    hideSave,
    onValidityChange,
    onSubmitted,
    onSubmitting,
    onError,
  } = props;
  const {
    handleSubmit,
    register,
    watch,
    formState: { isSubmitting, isValid, errors }
  } = useForm({ mode: 'onBlur'});
  const authContext = useContext(AuthContext);
  const [globalError, setGlobalError] = useState(null)
  const { t } = useTranslation();
  const onSubmit = async (data) => {
    try {
      setGlobalError(null)
      if(onSubmitting) {
        onSubmitting();
      }
      const password = data.password;
      if(password) {
        await authContext.updatePassword(password);
      }
      if(onSubmitted) {
        onSubmitted();
      }
    } catch (e) {
      setGlobalError(e.message);
      if(onError) {
        onError();
      }
      console.error(e);
    }
  };
  useEffect(() => {
    if(onValidityChange) {
      onValidityChange(isValid);
    }
  }, [isValid]);
  return (
    <>
      <Box>
        <form onSubmit={handleSubmit(onSubmit)} >
          <FormControl isInvalid={errors?.password} mb={2}>
              <FormLabel>{t('auth.newPassword')}</FormLabel>
              <Input
                placeholder={t('auth.password')}
                type="password"
                {...register('password', {
                  required: true,
                  minLength: {value: 6, message: t('auth.passwordMinLength')}
                })}
              />
              <FormErrorMessage>{errors?.password?.message}</FormErrorMessage>
            </FormControl>
            <FormControl isInvalid={errors?.confirmPassword} mb={3}>
              <FormLabel>{t('auth.confirmPassword')}</FormLabel>
              <Input
                placeholder={t('auth.confirmPassword')}
                type="password"
                {...register('confirmPassword', {
                  required: true,
                  minLength: {value: 6, message: t('auth.passwordConfirmationMinLength')},
                  validate: (val) => {
                    if (watch('password') != val) {
                      return t('auth.passwordsDoNotMatch');
                    }
                  },
                })}
              />
              <FormErrorMessage>{errors?.confirmPassword?.message}</FormErrorMessage>
            </FormControl>
            {globalError && (
              <Box mb={3}>
                <Text color={'text.medium.red'}>{globalError}</Text>
              </Box>
            )}
            <Button
              style={{
                display: hideSave ? 'none' : null,
              }}
              ref={ref}
              ml={2}
              type={'submit'}
              aria-label='check'
              variant='greyFill'
              isLoading={isSubmitting}
              isDisabled={!isValid}
            >
              {t('common.update')}
            </Button>
        </form>
      </Box>
    </>
  );
});
export default UpdatePasswordForm;
